import { render, staticRenderFns } from "./SetAdmin.vue?vue&type=template&id=677ca1b6&"
import script from "./SetAdmin.vue?vue&type=script&lang=js&"
export * from "./SetAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports